












import { Component, Vue } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import QuotationConditionsRepository from '@/services/QuotationConditionsRepository';
import QuotationConditionDialog from '@/components/catalog/QuotationConditionDialog.vue';
import { DxTextArea } from 'devextreme-vue/text-area';
import { DxTagBox } from 'devextreme-vue';
import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';

import { DxDataGrid, DxEditing, DxStateStoring, DxColumn, DxFormItem, DxLabel } from 'devextreme-vue/data-grid';

@Component({
  components: {
    DxDataGrid,
    DxEditing,
    DxStateStoring,
    DxColumn,
    DxFormItem,
    DxLabel,
    DxTextArea,
    DxTagBox,
    cCard,
    cDatagrid,
    QuotationConditionDialog,
  },
})
export default class QuotationConditionsOverview extends Vue {
  items: any[] = [];
  loading: boolean = false;
  saving: boolean = false;
  showConditionDialog: boolean = false;
  selectedConditionId: string = '';

  async mounted() {
    await this.loadData();
    this.$store.dispatch('articles/fetch');
  }

  async loadData() {
    try {
      this.loading = true;
      this.items = (await QuotationConditionsRepository.get()).data;
    } catch (err) {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  selectRow(e: any) {
    this.selectedConditionId = e.data.id;
    this.showConditionDialog = true;
  }

  add() {
    this.selectedConditionId = '';
    this.showConditionDialog = true;
  }

  refresh() {
    this.selectedConditionId = '';
    this.showConditionDialog = false;
    this.loadData();
  }

  deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        self.saving = true;
        await QuotationConditionsRepository.delete(e.data);
        notificationService.saved();
        resolve(false);
      } catch {
        notificationService.failedToSave();
      } finally {
        self.saving = false;
      }
      resolve(true);
    });
  }

  get columns() {
    return [
      {
        dataField: 'codeRefs',
        caption: this.$t('objects.quotationConditions.Articles'),
      },
      {
        dataField: 'projectTypes',
        caption: this.$t('objects.quotationConditions.ProjectTypes'),
      },
      {
        dataField: 'workTypes',
        caption: this.$t('objects.quotationConditions.WorkTypes'),
      },
      {
        dataField: 'value',
        caption: this.$t('objects.quotationConditions.Value'),
      },
      {
        type: 'buttons',
        buttons: ['delete'],
      },
    ];
  }
}
